import React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import App from "../App";
import LoginPage from "../components/loginPage/LoginPage";

export default function Routes(props) {
    return (
        <BrowserRouter>
            <Switch>
                <Route path={'/'} exact={true} render={props => <LoginPage {...props}/>}/>
                <Route path='/home' exact={true} render={props => <App {...props}/>}/>
            </Switch>
        </BrowserRouter>
    )
}